import { render } from "./ControlOfBoxes.vue?vue&type=template&id=e3578d60"
import script from "./ControlOfBoxes.vue?vue&type=script&lang=js"
export * from "./ControlOfBoxes.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__